<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/limited-subscription"
                saveRoot="/limited-subscription"
                @onTrashClick="onTrashClick"
                @onInit="onInit"
                :validation="validation"
                @isValid="isValid"
                @onInitSuccess="onInitSuccess"
                @onSaveSuccess="onSaveSuccess"
                :formStructure="dataFormStructures.limitedSubscription">
            <slot slot="beforeFormButtons">
                <b-button v-if="Core.Validation.isId(dataId)" @click="modelInvoiceOnClick" class="btn btn-light mr-2"><i class="fa fa-file-text mr-2"></i>{{Core.Definition.getDefinition('Facture')}}</b-button>
                <ModalInvoice ref="modalInvoice"></ModalInvoice>
            </slot>
        </DynamicForm>
        <ModalConfirm
                @onConfirm="replaceExpirationDate"
                :closeOnConfirm="true"
                :caption="Core.Definition.getDefinition('Date d\'expiration')"
                ref="modalConfirmReplaceExpirationDate">
            <slot slot="body">
                {{Core.Definition.getDefinition('Voulez-vous remplacer la date d\'expiration de cet abonnement par la nouvelle date d\'expiration calculée à partir des informations du produit sélectionné?')}}
            </slot>
        </ModalConfirm>
        <ModalTrash
                ref="trash"
                root="/limited-subscription"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'abon. limité')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet abon. limité?')"></ModalTrash>
    </div>
</template>

<script>
    var _self;
    import DynamicForm from '../../components/DynamicForm'
    import ModalConfirm from '../../components/ModalConfirm'
    import ModalTrash from '../../components/ModalTrash'
    import ModalInvoice from '../../components/ModalInvoice'

    export default {
        name: 'LimitedSubscription',
        components: {
            DynamicForm,
            ModalConfirm,
            ModalTrash,
            ModalInvoice
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataProduct: {
                    expirationPeriod: '',
                    expirationPeriodLength: '',
                    id: ''
                },
                dataFieldRefs: [],
                dataId: '',
                dataFormStructures: {
                    limitedSubscription: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Abonnement limité'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'expirationDate'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Client'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'userAction'
                                                                    },
                                                                    {
                                                                        id: 'userId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingFirstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingLastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingEmail'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingPhone'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'productLimitedSubscriptionSummary'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'bookingSummary'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'payments'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'status',
                                type: 'select',
                                label: Core.Definition.getDefinition('État'),
                                value: Core.Select.select(window.Mantle.Subscription.statusActivated, window.Mantle.Subscription.statusOptions()),
                                onSelect: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'expirationDate',
                                type: 'datePicker',
                                isInline: false,
                                description: Core.Definition.getDefinition('Ignoré si vide. Après cette date, l\'abonnement sera complété.'),
                                label: Core.Definition.getDefinition('Date d\'expiration'),
                                value: null,
                                onChange() {}
                            },
                            {
                                id: 'billingFirstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'billingLastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'billingEmail',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'billingPhone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label: 'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'notes',
                                type: 'notes',
                                options: [{
                                    label: Core.Definition.getDefinition('Normal'),
                                    value: 'normal'
                                },
                                    {
                                        label: Core.Definition.getDefinition('Privé'),
                                        value: 'private'
                                    }]
                            },
                            {
                                id: 'payments',
                                type: 'payments',
                                instance: Core.Product.typeStandard,
                                instanceId: 0,
                                total: 0,
                                forceTotal: false,
                                onTokenizationSuccess(payment) {
                                    _self.$refs.dynamicForm.addSaveArg('payment', JSON.stringify(payment))
                                    _self.$refs.dynamicForm.$refs.form.submit()
                                },
                                onPaymentCompleted(payment) {
                                    if (payment.method !== undefined) {
                                        switch(payment.method) {
                                            case Core.Payment.methodTerminal:
                                            case Core.Payment.methodCash:
                                                _self.$refs.dynamicForm.$refs.form.submit()
                                                break
                                        }
                                    }
                                },
                                onCheckPayment(){}
                            },
                            {
                                id: 'productLimitedSubscriptionSummary',
                                type: 'productLimitedSubscriptionSummary',
                                required: true,
                                value: [],
                                updateTotal: function(subTotal, total, form, fieldRefs) {
                                    fieldRefs['payments'].subTotal = subTotal
                                    fieldRefs['payments'].total = total
                                },
                                onChange: function(products, form, fieldRefs) {
                                    _self.dataFieldRefs = fieldRefs
                                    if (products !== null && products[0] !== undefined) {
                                        fieldRefs['bookingSummary'].dataBookingLimit = products[0].quantity
                                        let product = products[0].instance
                                        if (product.id !== _self.dataProduct.id) {
                                            _self.dataProduct = product
                                            if (!isNaN(product.expirationPeriodLength) && product.expirationPeriodLength > 0 && product.expirationPeriodLength !== undefined) {
                                                let currentExpirationDate = fieldRefs['expirationDate'].dataValue
                                                if (currentExpirationDate === null) {
                                                    _self.replaceExpirationDate()
                                                } else {
                                                    let expirationDate = new Date(Core.Date.calc(product.expirationPeriod, product.expirationPeriodLength, 'YYYY-MM-DD'))
                                                    if (currentExpirationDate.getDate() !== expirationDate.getDate()) {
                                                        _self.$refs.modalConfirmReplaceExpirationDate.open = true
                                                    }
                                                }
                                            } else {
                                                //_self.$refs.modalConfirmReplaceExpirationDate.open = true
                                            }
                                        }
                                    }
                                }
                            },
                            {
                                id: 'bookingSummary',
                                type: 'bookingSummary',
                                value: []
                            },
                            {
                                id: 'userId',
                                type: 'hidden',
                                value: ''
                            },
                            {
                                id: 'userAction',
                                type: 'userAction',
                                class: 'mb-3 pull-right',
                                updateUser: function(value, form, fieldRefs) {
                                    if (value.firstname === undefined) {
                                        value.firstname = ''
                                    }
                                    fieldRefs['billingFirstname'].dataValue = value.firstname

                                    fieldRefs['payments'].userId = value.id

                                    if (value.id === undefined) {
                                        value.id = ''
                                    }
                                    fieldRefs['userId'].dataValue = value.id

                                    if (value.lastname === undefined) {
                                        value.lastname = ''
                                    }
                                    fieldRefs['billingLastname'].dataValue = value.lastname

                                    if (value.email === undefined) {
                                        value.email = ''
                                    }
                                    fieldRefs['billingEmail'].dataValue = value.email

                                    if (value.phone === undefined) {
                                        value.phone = ''
                                    }
                                    fieldRefs['billingPhone'].dataValue = value.phone

                                    if (value.billingAddress === undefined) {
                                        value.billingAddress = ''
                                    }
                                    fieldRefs['billingAddress'].dataValue = value.billingAddress

                                    if (value.billingCountry === undefined) {
                                        value.billingCountry = 'CA'
                                    }
                                    fieldRefs['billingCountry'].dataValue = Core.Select.select(value.billingCountry, fieldRefs['billingCountry'].getOptions())

                                    if (value.billingCity === undefined) {
                                        value.billingCity = ''
                                    }
                                    fieldRefs['billingCity'].dataValue = value.billingCity

                                    if (value.billingZipcode === undefined) {
                                        value.billingZipcode = ''
                                    }
                                    fieldRefs['billingZipcode'].dataValue = value.billingZipcode

                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            isValid(isValid) {
                if (isValid === false) {

                }
            },
            validation(form, fieldRefs, structure) {
                return true
            },
            onInit() {
                if (Core.Validation.isId(this.$route.params.bookingId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initBookingId', this.$route.params.bookingId)
                }
                if (Core.Validation.isId(this.$route.params.userId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initUserId', this.$route.params.userId)
                }
                if (Core.Validation.isId(this.$route.params.productId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initProductId', this.$route.params.productId)
                }
            },
            onInitSuccess(data) {
                if (data.form !== undefined && data.form.userId !== undefined) {
                    this.$refs.dynamicForm.$refs.form.fieldRefs['payments'].userId = data.form.userId
                }
                if (data.form !== undefined && data.form.billingEmail !== undefined) {
                    this.$refs.modalInvoice.email = data.form.billingEmail
                }
            },
            replaceExpirationDate() {
                this.dataFieldRefs['expirationDate'].dataValue = null
                if (this.dataProduct.expirationPeriod !== undefined && this.dataProduct.expirationPeriod !== '') {
                    if (this.dataProduct.expirationPeriodLength !== undefined && !isNaN(this.dataProduct.expirationPeriodLength) && this.dataProduct.expirationPeriodLength > 0) {
                        let expirationDate = Core.Date.calc(this.dataProduct.expirationPeriod, this.dataProduct.expirationPeriodLength)
                        this.dataFieldRefs['expirationDate'].dataValue = new Date(expirationDate)
                    }
                }
            },
            onSaveSuccess() {
                this.$refs.dynamicForm.$refs.request.clearArgs()
                this.$refs.dynamicForm.clearSaveArgs()
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/commerce/abonnements-limites')
            },
            modelInvoiceOnClick() {
                this.$refs.modalInvoice.instanceType = 'limitedSubscription'
                this.$refs.modalInvoice.instanceId = this.dataId
                this.$refs.modalInvoice.open = true
            }
        }
    }
</script>
